module.exports = __webpack_public_path__ + "img/calendar-rose.6be27b7a.svg";